document.addEventListener("DOMContentLoaded", function() {
  // Find the product price element
  var priceElement = document.querySelector('.product__price');

  if (priceElement) {
    // Get the price text
    var priceText = priceElement.innerText;

    // Check if the price has cents
    if (priceText.indexOf('.00') !== -1) {
      // Price is a whole number, remove ".00"
      priceElement.innerText = priceText.replace('.00', '');
    } else {
      // Price has cents, keep it as is
      priceElement.innerText = priceText;
    }
  }


});



document.addEventListener('click', function() {
  // Find the product price element
  //delay for 1 second
  setTimeout(function(){
    var priceElement = document.querySelector('.product__price');

    if (priceElement) {
      // Get the price text
      var priceText = priceElement.innerText;

      // Check if the price has cents
      if (priceText.indexOf('.00') !== -1) {
        // Price is a whole number, remove ".00"
        priceElement.innerText = priceText.replace('.00', '');
      } else {
        // Price has cents, keep it as is
        priceElement.innerText = priceText;
      }
    }
  }, 1);

});
